export default __webpack_public_path__ + "static/media/Ballroll_00144.f7d2aafd.png";